import { render } from "./DeliveryInspection.vue?vue&type=template&id=223f7928&scoped=true"
import script from "./DeliveryInspection.vue?vue&type=script&lang=js"
export * from "./DeliveryInspection.vue?vue&type=script&lang=js"

import "./DeliveryInspection.vue?vue&type=style&index=0&id=223f7928&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223f7928"]])

export default __exports__